import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CallToAction() {
  return (
    <section className="relative overflow-hidden bg-white py-24">
      {/* Light Background Wash for page flow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,#dbeafe_0%,transparent_70%)] opacity-60"></div>

      {/* Grid Pattern */}
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0,0,0,.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,0,0,.04) 1px, transparent 1px)
          `,
          backgroundSize: "60px 60px",
        }}
      ></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        {/* Card wrapper: BG matched to Hero Section theme color (#03152d) */}
        <div className="relative overflow-hidden rounded-[32px] border border-white/10 bg-gradient-to-br from-[#03152d] to-[#0a1a36] px-8 md:px-20 py-24 text-center shadow-[0_20px_60px_rgba(3,21,45,.35)]">
          {/* Ambient Inner Glows */}
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full bg-[#355dff]/10 blur-[140px]" />
          <div className="absolute bottom-[-120px] right-[-100px] w-[350px] h-[350px] rounded-full bg-cyan-500/10 blur-[120px]" />

          {/* Badge */}
          <div className="inline-flex items-center gap-2 rounded-full border border-cyan-500/30 bg-cyan-500/10 px-5 py-2">
            <Sparkles size={16} className="text-cyan-400" />
            <span className="text-cyan-300 font-medium">Ready to Build?</span>
          </div>

          {/* Heading */}
          <h2 className="mt-8 text-5xl md:text-7xl font-black leading-tight">
            <span className="text-white">Let's Create Something</span>
            <br />
            <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-indigo-300 bg-clip-text text-transparent">
              Extraordinary
            </span>
          </h2>

          {/* Description */}
          <p className="mt-8 max-w-2xl mx-auto text-gray-400 text-xl leading-9">
            <span className="text-cyan-400 mr-2">•</span>
            Join leading businesses who have transformed their digital presence with Orryworx. Your vision, our execution.
          </p>

          {/* Button Link */}
          <div className="mt-14">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 rounded-2xl bg-gradient-to-r from-blue-600 to-[#355dff] px-10 py-5 text-xl font-semibold text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(53,93,255,.45)]"
            >
              Start Your Project
              <ArrowRight
                size={22}
                className="transition-transform duration-300 group-hover:translate-x-2"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}